import './App.css';
import UrlShortner from './UrlShortner';

function App() {
  return (
    <div className="app">
        <UrlShortner />
    </div>
  );
}

export default App;
